import type { NavigateFunction } from 'react-router-dom';
import { administrationMenuItem } from '../config/adminNavigation';

export const ADMIN_BACK_STORAGE_KEY = 'eone.adminBackTo';

export interface AdminNavigationState {
  adminBackTo?: string;
}

export function persistAdminBackTo(path: string): void {
  sessionStorage.setItem(ADMIN_BACK_STORAGE_KEY, path);
}

export function readAdminBackTo(): string | null {
  return sessionStorage.getItem(ADMIN_BACK_STORAGE_KEY);
}

export function clearAdminBackTo(): void {
  sessionStorage.removeItem(ADMIN_BACK_STORAGE_KEY);
}

export function isValidAdminBackTarget(path: string): boolean {
  if (path === administrationMenuItem.path) return true;
  return /^\/configuraciones\/[a-z0-9-]+$/.test(path);
}

export function navigateWithAdminBack(
  navigate: NavigateFunction,
  targetPath: string,
  adminBackTo: string,
): void {
  persistAdminBackTo(adminBackTo);
  navigate(targetPath, { state: { adminBackTo } satisfies AdminNavigationState });
}
